<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des livraisons</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div v-if="props.row.date_livraison" slot="date_livraison" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_livraison) }}</span>
          </div>
          <div v-if="props.row.is_active==true" slot="is_active" slot-scope="props" class="slot-center">
            <span class="badge badge-success p-1"><i class="fa fa-check"></i></span>
          </div>
          <div v-else-if="props.row.is_active==false || props.row.is_active==null" slot="is_active" slot-scope="props" class="slot-center">
            <span class="badge badge-danger p-1"><i class="fa fa-close"></i></span>
          </div>
          <div slot="action" slot-scope="props">
            <span v-if="canAccess(rules.CAN_MANAGE_LIVRAISONS)">
              <i class="fa fa-pencil mr-2 text-primary clickable" @click="editLivraison(props.row.id)"></i>
            </span>
            <span>
              <i v-b-tooltip.hover.lefttop title="Voir la livraison" class="fa fa-eye fa-1_5x text-primary clickable mr-1" @click="showLivraison(props.row)"></i>
            </span>
            <span v-if="canAccess(rules.CAN_MANAGE_LIVRAISONS)">
              <i class="fa fa-trash clickable text-danger ml-2" @click.prevent="destroy(props.row.id)"></i>
            </span>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer" v-if="canAccess(rules.CAN_MANAGE_LIVRAISONS)">
        <b-button type="button" @click="addLivraison" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une livraison
        </b-button>
      </div>
    </b-card>

    <b-modal size="lg" scrollable centered id="modal-livraison" ref="modal-livraison" :title="'v ' + versionAtlas + ' du ' + dateVersion">
      <b-row class="mb-1">
        <b-col sm="12">
          <div class="block-livraison" v-html="contenu"></div>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" @click="$bvModal.hide('modal-livraison')" class="btn btn-secondary"> Fermer</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from "../../../utils/auth";
  import { rules, hasRule } from '@/utils/rulesHelper';

  export default {
    name: "List",
    data() {
      return {
        rules: rules,
        columns: ['date_livraison', 'titre', 'numero_version', 'commentaire', 'is_active', 'action'],
        data: [],
        contenu: '',
        dateVersion: '',
        versionAtlas: '',
        options: {
          headings: {
            'date_livraison': 'Date',
            'titre': 'Titre',
            'numero_version' : 'Version',
            'commentaire': 'Commentaire',
            'is_active': 'Active',
            'action': 'Action'
          },
          sortable: ['date_livraison'],
          filterable: ['titre'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Titre"
          },
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    methods: {
      canAccess(rule) {
        return hasRule(rule)
      },
      all() {
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .get("/administration/livraisons/list")
          .then(response => {
            this.data = response.data.livraisons
            this.$store.commit('IS_LOADING', false)
          })
          .catch(() => {
            this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un probléme est survenue, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer cette livraison ?" + id,
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .post("/administration/livraisons/delete/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "La livraison a bien été supprimée",
                    showConfirmButton: false,
                    timer: 4000
                  })
                  this.all()
                })
                .catch(() => {
                  self.$store.commit('IS_LOADING', false)
                  self.$swal({
                    position: 'top',
                    type: 'warning',
                    title: 'Attention !!',
                    text: 'Un problème est survenu, merci de contacter un administrateur',
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })

      },
      addLivraison() {
        this.$router.push({path: '/administration/livraisons/add'})
      },
      editLivraison(id) {
        this.$router.push({path: '/administration/livraisons/edit/' + id})
      },
      showLivraison(item) {
        this.versionAtlas = item.numero_version
        this.dateVersion = this.formatDate(item.date_livraison)
        this.idVersion = item.id
        this.contenu = item.contenu

        this.$refs['modal-livraison'].show()
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      },
    }
  }
</script>
